<div class="container u-mt60">
    <div class="row">
        <div class="col-12">
            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="">
                            Inicio
                        </a>
                    </li>
                    <li>
                        <a href="">
                            FAQ
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-12">
            <h1 class="u-mb10 txt txt--title">
                Requisitos
            </h1> 
            <a href="" class="back back--small  u-mb20">
                Preguntas Frecuentes
            </a>
        </div>
        <div class="col-md-12 u-pt30 u-pb10 u-mb60">
          <h3 class="txt txt--subtitle">
            Requisitos asociados a zonas, equipos o al conductor
          </h3>
          <p class="txt txt--paragraph">
            Las casillas seleccionadas indica quienes tendrán acceso en cada pantalla descrita. 
          </p>
        </div>
        <div class="col-md-12">
            <div class="u-image">
                <div class="imagescroll">
                    <img src="../../dist/img/requisitos.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</div>